import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { api } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";
import { Zap, Lock } from "lucide-react";

export default function AdminLoginPage() {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (localStorage.getItem("kk_token")) {
    return <Navigate to="/admin" replace />;
  }

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.post("/auth/login", { username, password });
      localStorage.setItem("kk_token", res.data.access_token);
      toast.success("Bun venit!");
      navigate("/admin");
    } catch (err) {
      toast.error("Credentiale invalide");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 bg-[#0A0A0A] kk-grid-bg">
      <div data-testid="admin-login-page" className="w-full max-w-md bg-neutral-950 border border-neutral-800 p-8">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-11 h-11 bg-[#00E5FF] flex items-center justify-center kk-orange-glow">
            <Zap className="w-6 h-6 text-black" strokeWidth={3} />
          </div>
          <div>
            <div className="font-display text-xl text-white leading-none">TROTI-X ADMIN</div>
            <div className="text-[10px] tracking-[0.3em] text-[#00E5FF] uppercase mt-1">Control room</div>
          </div>
        </div>

        <form onSubmit={submit} className="space-y-5">
          <div className="space-y-2">
            <Label className="text-xs uppercase tracking-wider text-neutral-400">Utilizator</Label>
            <Input data-testid="admin-username" value={username} onChange={(e) => setUsername(e.target.value)} className="bg-neutral-900 border-neutral-800 focus:border-[#00E5FF] rounded-none" />
          </div>
          <div className="space-y-2">
            <Label className="text-xs uppercase tracking-wider text-neutral-400">Parola</Label>
            <Input data-testid="admin-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="bg-neutral-900 border-neutral-800 focus:border-[#00E5FF] rounded-none" />
          </div>
          <Button type="submit" disabled={loading} data-testid="admin-login-btn" className="w-full bg-[#00E5FF] hover:bg-[#5CEEFF] text-black font-semibold uppercase tracking-wider rounded-none h-11">
            <Lock className="w-4 h-4 mr-2" /> {loading ? "Se conecteaza..." : "Autentifica-te"}
          </Button>
        </form>
      </div>
    </div>
  );
}
